<template>
  <div class="align-center d-flex">
    <v-menu bottom left offset-y transition="slide-y-transition" v-if="allSolutions">
      <template v-slot:activator="{ attrs, on }">
        <v-btn rounded small class="toolbar-items" text v-bind="attrs" v-on="on" color="white" >
          {{allSolutions.find(o=>o.id == solutionID).name}}
          <v-icon right size="20">mdi-checkbox-marked-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list dense>
          <v-list-item v-for="solution in allSolutions" :key="solution.id" @click="writeSolutionID({id: solution.id})" >
            <v-list-item-title v-text="solution.name" />
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
export default {
  data(){
    return{
      fab: false,
      solutions:[
        "Pré-Uso",
        "Auditoria Interna",
        "Qualidade",
        "B.O"
      ]
    }
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      allSolutions: state => state.Solution.allSolutions,
      solutionID: state => state.Solution.solutionID,
      // data: state=> state.Module.state_var
    })
  },
  methods: {
    ...mapActions({
      writeSolutionID: 'Solution/writeSolutionID',
    })
  },
}
</script>

<style>

</style>